import { Button, TextField, IconButton, Switch } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
  AdminItemsRow,
  AdminItemsContainer,
  AdminItemContainer,
} from "../../admin.styled"; // Adjust imports accordingly
import { Report } from "../../admin.type";
import { useState } from "react";
import { deleteReport } from "modules/agentMySecurity/services/embeddingsService";
import { Toast } from "core/components/global/toast/toast";
import { ConfirmationDialog } from "core/components/global/confirmationDialogBox/confirmationDialog";
import { formatDate } from "core/lib/utils";

export default function AdminReport({ report, handleUpdateReport, onDelete }) {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const [openRow, setRowOpen] = useState(false);

  const [schedule, setschedule] = useState(report.schedule);
  const [recipients, setrecipients] = useState(report.recipients);
  const [name, setname] = useState(report.name);
  const [description, setdescription] = useState(report.description);
  const [emailSubject, setemailSubject] = useState(report.emailSubject);
  const [isChecked, setIsChecked] = useState(report.active);

  const [openDialog, setOpenDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const preHandleUpdateReport = () => {
    handleUpdateReport(
      {
        _id: report._id,
        schedule: schedule,
        recipients: recipients,
        name: name,
        description: description,
        emailSubject: emailSubject,
        active: isChecked,
      },
      report._id
    );
  };

  // Locally update the list of invites
  const handleReportChange = (
    currentReport: Report,
    field: string,
    value: any
  ) => {
    if (field === "schedule") {
      setschedule(value);
    } else if (field === "recipients") {
      setrecipients(value);
    } else if (field === "name") {
      setname(value);
    } else if (field === "description") {
      setdescription(value);
    } else if (field === "emailSubject") {
      setemailSubject(value);
    } else if (field === "active") {
      setIsChecked(!value);
    }
  };

  const handleDeleteClick = () => {
        setOpenDialog(true);
    };
    
    const handleDelete = async () => {
    try {
        setIsDeleting(true);
        const response = await deleteReport(report._id);
        if (response !== null) {
        onDelete(report._id);
        Toast("Invite deleted successfully", "success");
        } else {
        Toast("Failed to delete invite", "error");
        }
    } catch (error) {
        console.error("Delete error:", error);
        Toast("Error deleting invite", "error");
    } finally {
        setIsDeleting(false);
        setOpenDialog(false);
    }
    };

  return (
    <AdminItemsRow>
      <div className="unexpanded-row-container">
        <div className="row-items" onClick={() => setRowOpen(!openRow)}>
          <p className="row-item">{report.name}</p>
          <p className="row-item">{report.schedule}</p>
          <p className="row-item">{formatDate(report.createdAt)}</p>
          {/* <Switch
            {...label}
            checked={!isChecked}
            disabled={true}
          /> */}
        </div>
        <div className="row-buttons">
            <IconButton onClick={handleDeleteClick} disabled={isDeleting}>
                <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
            </IconButton>
        </div>
      </div>

      {openRow && (
        <AdminItemsContainer>
          <AdminItemContainer>
            <strong>Name:</strong>
            <TextField
              value={name}
              onChange={(e) =>
                handleReportChange(report, "name", e.target.value)
              }
              variant="outlined"
              fullWidth
            />
          </AdminItemContainer>

          <AdminItemContainer>
            <strong>Description:</strong>
            <TextField
              value={description}
              onChange={(e) =>
                handleReportChange(report, "description", e.target.value)
              }
              variant="outlined"
              fullWidth
            />
          </AdminItemContainer>

          <AdminItemContainer>
            <strong>Schedule: (Cron Expression)</strong>
            <TextField
              value={schedule}
              onChange={(e) =>
                handleReportChange(report, "schedule", e.target.value)
              }
              variant="outlined"
              fullWidth
            />
          </AdminItemContainer>

          <AdminItemContainer>
            <strong>Recipients: (Comma Separated)`</strong>
            <TextField
              value={recipients}
              onChange={(e) =>
                handleReportChange(report, "recipients", e.target.value)
              }
              variant="outlined"
              fullWidth
            />
          </AdminItemContainer>

          <AdminItemContainer>
            <strong>Email Subject:</strong>
            <TextField
              value={emailSubject}
              onChange={(e) =>
                handleReportChange(report, "emailSubject", e.target.value)
              }
              variant="outlined"
              fullWidth
            />
          </AdminItemContainer>

          <AdminItemContainer>
            <strong>Active:</strong>
            <Switch
              {...label}
              checked={!isChecked}
              onChange={(e) =>
                handleReportChange(report, "active", e.target.checked)
              }
            />
          </AdminItemContainer>

          <Button
            color="primary"
            onClick={() => preHandleUpdateReport()}
            variant="outlined"
            className="align-self-baseline"
          >
            Update Report
          </Button>
        </AdminItemsContainer>
      )}
      <ConfirmationDialog
          open={openDialog}
          title="Confirm Delete"
          message={`Are you sure you want to delete the report ${report.name}?`}
          isLoading={isDeleting}
          onClose={() => setOpenDialog(false)}
          onConfirm={handleDelete}
      />
    </AdminItemsRow>
  );
}
